import { v4 as uuidv4 } from "uuid";

const firstVisitKey = "Mt.firstVisitInfo";
const currentVisitKey = "Mt.currentVisitInfo";
const visitorIdKey = "Mt.visitorId";

const captureVisitInfo = (location) => {
  const params = new URLSearchParams(location.search);

  const data = {
    event_timestamp: getCurrentTimestamp(),
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_content: params.get("utm_content"),
    utm_term: params.get("utm_term"),
    gclid: params.get("gclid"),
    msclkid: params.get("msclkid"),
    url: location.href,
    referrer: document.referrer,
  };

  return data;
};

export const storeVisitorId = () => {
  let visitorId = getLocalStorage(visitorIdKey);
  if (!visitorId) {
    visitorId = uuidv4().replace(/-/g, "");
    setLocalStorage(visitorIdKey, visitorId);
  }
};

export const storeFirstVisitInfo = (location) => {
  let data = getLocalStorage(firstVisitKey);
  if (!data) {
    data = captureVisitInfo(location);
    setLocalStorage(firstVisitKey, data, true);
  }
};

export const storeCurrentVisitInfo = (location) => {
  let existingCurrentVisitData = getLocalStorage(currentVisitKey, true);
  let newCurrentVisitData = captureVisitInfo(location);
  let currentTime = getCurrentTimestamp();
  let sessionExpired;
  let secondsSinceLastEvent;

  if (existingCurrentVisitData?.event_timestamp && currentTime) {
    secondsSinceLastEvent = currentTime - existingCurrentVisitData.event_timestamp;
    sessionExpired = secondsSinceLastEvent > 1800 ? true : false;
  } else {
    sessionExpired = true;
  }

  let newUTM = [
    newCurrentVisitData.utm_source,
    newCurrentVisitData.utm_medium,
    newCurrentVisitData.utm_campaign,
    newCurrentVisitData.utm_content,
    newCurrentVisitData.utm_term,
  ].join("");

  if (existingCurrentVisitData && !newUTM && sessionExpired === false) {
    // Only update the last session event time and leave all other current visit info if:
    // There is existing current visit data, and
    // The new data has no UTM params, and
    // The session has not expired (less than 30 minutes since last event)
    existingCurrentVisitData.event_timestamp = currentTime;
    setLocalStorage(currentVisitKey, existingCurrentVisitData, true);
  } else {
    setLocalStorage(currentVisitKey, newCurrentVisitData, true);
  }
};

export const getVisitInfo = (type, stringify = false) => {
  let key;

  if (type === "first") {
    key = firstVisitKey;
  } else if (type === "current") {
    key = currentVisitKey;
  }

  let visitData = getLocalStorage(key, true);
  const visitorId = getLocalStorage(visitorIdKey);
  const phId = window?.posthog?.get_distinct_id?.();

  if (visitData) {
    visitData.mt_visitor_id = visitorId;
    visitData.ph_id = phId;
  }

  if (stringify) {
    try {
      return JSON.stringify(visitData);
    } catch (e) {
      console.error(e);
      return null;
    }
  } else {
    return visitData;
  }
};

export const getVisitInfoVerbose = (type) => {
  const f = getVisitInfo(type);

  let verboseObj = {};

  verboseObj[type + "_visit_event_timestamp"] = f?.event_timestamp;
  verboseObj[type + "_visit_utm_source"] = f?.utm_source;
  verboseObj[type + "_visit_utm_medium"] = f?.utm_medium;
  verboseObj[type + "_visit_utm_campaign"] = f?.utm_campaign;
  verboseObj[type + "_visit_utm_content"] = f?.utm_content;
  verboseObj[type + "_visit_utm_term"] = f?.utm_term;
  verboseObj[type + "_visit_gclid"] = f?.gclid;
  verboseObj[type + "_visit_msclkid"] = f?.msclkid;
  verboseObj[type + "_visit_url"] = f?.url;
  verboseObj[type + "_visit_visitor_id"] = f?.mt_visitor_id;
  verboseObj[type + "_visit_ph_id"] = f?.ph_id;
  verboseObj[type + "_visit_referrer"] = f?.referrer;

  return verboseObj;
};

const getLocalStorage = (key, parse_json = false) => {
  let value;

  try {
    value = localStorage.getItem(key);
  } catch (e) {
    console.error(e);
    value = null;
  }

  if (parse_json) {
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error(e);
      return null;
    }
  } else {
    return value;
  }
};

const setLocalStorage = (key, value, stringify = false) => {
  if (stringify) {
    try {
      value = JSON.stringify(value);
    } catch (e) {
      console.error(e);
      value = null;
    }
  }

  try {
    localStorage.setItem(key, value);
    return value;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const getCurrentTimestamp = () => {
  try {
    return Math.floor(Date.now() / 1000);
  } catch (e) {
    console.error(e);
    return null;
  }
};
